import React from 'react';
export var Delete = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: color },
        React.createElement("path", { d: "m22 12.996-6 6M16 12.996l6 6M14.828 8H24a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-9.172a2 2 0 0 1-1.413-.585l-7.122-6.712a.999.999 0 0 1 0-1.414l7.122-6.708A2 2 0 0 1 14.828 8v0Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
